module.exports = __webpack_public_path__ + "img/shield-off.5b335e4f.svg";